<template>
  <vf-dialog-layout class-wrapper="!p-0" data-scroll-el="filtersPanel">
    <template #title>
      {{ $t.filterAndSort }}
    </template>
    <product-list-filters
      v-bind="$props"
      class="px-4 pb-4"
      @change="$emit('change', $event)"
      @change-store="$emit('changeStore', $event)"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
      @sort="$emit('sort', $event)"
    />
    <template #footer>
      <div class="grid cols-2 gap-4">
        <vf-button variant="secondary" @click="$emit('clear')">
          {{ $t.clearAll }}
        </vf-button>
        <vf-button @click="$emit('resolve')">
          {{ replaceAll($t.seeResults, { total }) }}
        </vf-button>
      </div>
    </template>
  </vf-dialog-layout>
</template>

<script lang="ts" setup>
import type { SortType } from '#types/config/pages/plp'
import type { FiltersMap } from '#types/filters'

export type Props = {
  heading?: string
  total: number
  currency?: string
  filters: FiltersMap
  sortOptions?: { value: SortType, label: string }[]
  filtersQuery?: Record<string, string[]>
  loading?: boolean
  pickupFilters: boolean
  sortState?: string
  storeFilterState?: string
}
export type Emits = {
  clear: []
  change: [payload: { code: string, selected: string[] }]
  changeStore: [payload: string | undefined]
  remove: [payload: { code: string, id: string }]
  resolve: []
  sort: [payload: string]
}

defineProps<Props>()
defineEmits<Emits>()
</script>
